import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { API_V7_URL } from '../../constants/Globals';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ArchiveOrganization({ groupId }) {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const { t } = useTranslation();
  const kTrans = t ? t : () => {};

  const handleArchive = async () => {
    try {
      await axios.delete(
        `${API_V7_URL}/api/master/groups/${groupId}/archive`,
        {}
      );

      alert('Organization archived successfully');
      setOpen(false);
      window.location.href = '/organizations';
    } catch (err) {
      console.error("Error archiving organization:", err);
      alert("Error in archiving organization");
    }
  };

  return (
    <>
      {/* Trigger */}
      <div
        style={{ color: 'red', cursor: 'pointer' }}
        onClick={(e) => {
          e.stopPropagation(); // prevents parent click
          e.preventDefault();
          setOpen(true);
        }}
      >
        Archive Organization
      </div>

      {/* Modal */}
      {open && (
        <div
          className="archive-org-modal-overlay"
          onClick={() => setOpen(false)}
        >
          <div
            className="archive-org-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <p style={{fontSize: '20px'}}>Do you want to archive this organization?</p>

            <div className="archive-org-actions">
              <Button variant="secondary" className="mx-1" onClick={() => setOpen(false)}>
                {kTrans("Cancel")}
              </Button>
              <Button variant="primary"
                type="button"
                className="archive-org-button danger"
                onClick={handleArchive}
              >
                {kTrans("Yes, Archive")}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ArchiveOrganization;
